// Category badges and chips: rounded squares in the category's deep tint with white glyphs, and
// chips at 16% tint, as in the app.

import type { CSSProperties } from "react";
import { type Category, colorChartTint, colorTint } from "../domain/categories.ts";
import { Icon } from "./Icon.tsx";

export function tintStyle(category: Category): CSSProperties {
  return { "--tint": colorTint[category.color] } as CSSProperties;
}

export function chartStyle(category: Category): CSSProperties {
  return { "--k": colorChartTint[category.color] } as CSSProperties;
}

export function CategoryBadge({ category, small }: { category: Category | undefined; small?: boolean }) {
  if (!category) {
    return <span className={`cv-badge is-unc${small ? " cv-badge-sm" : ""}`}><Icon name="road" /></span>;
  }
  return (
    <span className={`cv-badge${small ? " cv-badge-sm" : ""}`} style={tintStyle(category)}>
      <Icon name={category.symbol} />
    </span>
  );
}

export function CategoryChip({ category }: { category: Category | undefined }) {
  if (!category) return <span className="cv-chip is-unc">Unclassified</span>;
  return <span className="cv-chip" style={tintStyle(category)}>{category.name}</span>;
}
